import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrailblazerFilterSearchingViewModel } from './trailblazer.types';
import { Tc } from '../../../core/_infrastructure/types/common';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class TrailblazerService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getDataViews(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/mantenimiento/trailblazer/dataviews').pipe();
    }

    postTrailblazerPagedByFilter(model: TrailblazerFilterSearchingViewModel): Observable<any> {
        return this.http.post<TrailblazerFilterSearchingViewModel>(this.baseUrl + 'api/mantenimiento/trailblazer/postPagedbyfilter', model).pipe();
    }

    export(model: TrailblazerFilterSearchingViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/trailblazer/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }
}
